import { ReadonlyURLSearchParams } from "next/navigation";

interface IFilters {
  [key: string]: number[] | string[];
}
export const clearAllFilters = (filtersIds: any) => {
  const idsObj = { ...filtersIds };
  let queries = [];
  for (let key in idsObj) {
    idsObj[key] = [];
    queries.push({ name: key, val: "" });
  }
  return { filterState: idsObj, queries };
};
export const prepareQueryToRouter = (filtersIds: any) => {
  let queries = [];
  for (let [key, value] of Object.entries(filtersIds)) {
    const joinedValue = (value as Array<string>).join(",");
    // Only include filters that have actual values
    if (joinedValue && joinedValue.trim() !== "") {
      queries.push({ name: key, val: joinedValue });
    } else {
      // Include empty value to ensure it gets removed from URL
      queries.push({ name: key, val: "" });
    }
  }
  return queries;
};
export const filtersEmpty = (filterIds: any) => {
  if (Object.keys(filterIds).length === 0) return true;
  for (let key in filterIds) {
    if (filterIds[key].length > 0) return false;
  }
  return true;
};
export const getCurrFilters = (
  searchParams: ReadonlyURLSearchParams | null,
  filtersIds: any,
) =>
  Object.keys(filtersIds)
    .map((key) => searchParams?.get(key) ?? [])
    .flat();

export const isFiltesEqual = (
  searchParams: ReadonlyURLSearchParams | null,
  filterIds: IFilters,
) => {
  const areSetsEqual = (a: Set<any>, b: Set<any>) =>
    a.size === b.size && [...a].every((value) => b.has(value));
  const ids1Set = new Set(Object.values(filterIds).flat());
  const ids2Set = new Set(getCurrFilters(searchParams, filterIds));
  return areSetsEqual(ids1Set, ids2Set);
};
